import { auth } from "services/firebaseConfig";

export async function logoutUser(){
    await auth.signOut();
}